import React from 'react';
import { connect } from 'react-redux';

import TextEditor from 'components/TextEditor';
import * as actions from 'actions';
import { getMailTextEditing, getMailEmojis } from 'selectors';
import './style.scss';

const MailThreadMessageEditor = (props) => <TextEditor {...props} maxChars={process.env.KOOTH_MAX_CHARS} />;

const mapStateToProps = state => {
  return {
    ...getMailTextEditing(state, 'replyToMessage'),
    showsEmojis: getMailEmojis(state, 'replyToMessage').areVisible
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onTextUpdate: (text) => {
      dispatch(actions.mailThreadMessageEditingUpdateText({ text }));
    },
    onSubmit: (text) => {
      dispatch(actions.mailThreadMessageCreate(props.threadId, text));
      dispatch(actions.mailEmojisHide('replyToMessage'));
    },
    onFocus: () => {
      dispatch(actions.mailThreadMessageEditingExpand());
    },
    onWillUnmount: () => {
      dispatch(actions.mailEmojisHide('replyToMessage'));
      dispatch(actions.mailThreadMessageEditingReset());
    },
    onEmojisToggled: (showsEmojis) => {
      if(showsEmojis) {
        dispatch(actions.mailEmojisHide('replyToMessage'));
      }
      else {
        dispatch(actions.mailEmojisShow('replyToMessage'));
      }
    },
    onEmojiSelected: (text, emojiShortName, selectionStart) => {
      dispatch(actions.mailThreadMessageEditingUpdateText({ text, emojiShortName, selectionStart }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailThreadMessageEditor);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadMessagesList/MailThreadMessageEditor/index.js
 **/